<template>
  <v-container fluid>
    <v-flex sm4>
      <v-form>
        <content-field
          label="Name"
          hint="Please, enter recipient's name"
          :error="$v.formData.name"
          @blur="$v.formData.name.$touch()"
          v-model="formData.name"
          required
        />
        <content-field
          label="Company"
          hint="Please, enter recipient's company name"
          :error="$v.formData.company"
          @blur="$v.formData.company.$touch()"
          v-model="formData.company"
          required
        />
        <content-field
          label="E-mail"
          hint="Please, enter recipient's e-mail"
          :error="$v.formData.email"
          @blur="$v.formData.email.$touch()"
          v-model="formData.email"
          required
        />
        <v-checkbox
          label="Sponsor of Blitz Networking"
          v-model="formData.isSponsor"
        ></v-checkbox>
        <v-select
          :items="participantsCountList"
          v-model="formData.participantsCount"
          label="Select maximum partcipants count"
          required
        />
        <v-select
          :items="blitzInvitationTemplatesList"
          v-model="formData.emailTemplateKey"
          item-text="templateKey"
          item-value="templateKey"
          label="Select email template"
          required
        />
        <v-btn @click="submit" :disabled="$v.$invalid || !isWriteAvailable">submit</v-btn>
        <v-btn @click="clear">clear</v-btn>
      </v-form>
    </v-flex>
    <e-small-modal
      :isOn="getLetter.showMessage"
      :link="getLink()"
      @close="onModalClose"
    />
  </v-container>
</template>

<script>
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import { mapGetters, mapActions } from 'vuex'
  import ESmallModal from './modal'
  import mixins from '@/utils/mixins'

  export default {
    components: {
      ESmallModal
    },
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    data () {
      return {
        formData: {
          name: '',
          email: '',
          company: '',
          isSponsor: false,
          participantsCount: 1,
          emailTemplateKey: ''
        },
        participantsCountList: [1, 2, 3],
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'blitz:write'
      }
    },
    validations: {
      formData: {
        name: { required, maxLength: maxLength(20) },
        company: { required, maxLength: maxLength(20) },
        email: { required, email },
        participantsCount: { required },
        emailTemplateKey: { required }
      }
    },
    computed: {
      ...mapGetters(['getLetter'])
    },
    methods: {
      ...mapActions(['sendSingleLetter', 'closeLetterModal']),
      async submit () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        await this.sendSingleLetter({ payload: this.formData, route: 'blitz' })
      },
      clear () {
        this.$v.$reset()
        this.formData.name = ''
        this.formData.company = ''
        this.formData.email = ''
        this.formData.participantsCount = 1
        this.formData.emailTemplateKey = ''
      },
      getLink () {
        let link = '' // initial value returned if there's no link
        if (this.getLetter.showMessage) link = this.getLetter.data.invitationLink

        return link
      },
      onModalClose () {
        this.closeLetterModal()
        this.clear()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/BlitzInvitation/single.vue